import React from "react";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {generateMetaRegionNameDeclensionWhere} from "../../../meta_data/utils/generate_meta_region_name_declension_where";
import {RegionType} from "../../../region/types/RegionType";

interface IProps {
    allOffersCount: number;
    className?: string;
    vendorsCount: number;
    region:
        | {
              full_name: string;
              is_duplicate: boolean;
              name: string;
              name_declension_what: string;
              name_declension_where: string;
              parent: {
                  name: string;
              } | null;
              short_name: string;
              stats: {
                  offers_count_for_sale: number;
              };
              type: RegionType;
          }[]
        | null;
    page: number;
}

export const VendorListHeader = (props: IProps) => {
    const vendorsPluralize = pluralize(["dewelopera", "deweloperów", "deweloperów"]);
    const offersPluralize = pluralize(["inwestycję", "inwestycje", "inwestycji"]);

    return (
        <header className={props.className}>
            {props.vendorsCount === 0 && (
                <SeoMainHeadline as="h1" variant="headline_2" css={pb(1)}>
                    Brak deweloperów {props.region && props.region[0] ? generateMetaRegionNameDeclensionWhere(props.region[0]) : "w wybranym regionie"}
                </SeoMainHeadline>
            )}
            {props.vendorsCount > 0 && (
                <>
                    <SeoMainHeadline as="h1" variant="headline_2" highlight css={pb(1)} prefixContent="Znaleźliśmy" pageString={` - Strona ${props.page}`}>
                        {numberFormat(props.vendorsCount)} {vendorsPluralize(props.vendorsCount)}{" "}
                        {props.region && props.region[0] ? generateMetaRegionNameDeclensionWhere(props.region[0]) : "z całej Polski"}
                        {props.page > 1 && (
                            <>
                                {" - "}
                                <span css={nonBreakable}>Strona {props.page}</span>
                            </>
                        )}
                    </SeoMainHeadline>

                    <Text as="h2" variant="body_copy_1" css={subheaderStyle}>
                        Aktualnie nasi deweloperzy{" "}
                        {props.region
                            ? `${props.region[0].name_declension_where} realizują ${numberFormat(
                                  props.region[0].stats.offers_count_for_sale
                              )} ${offersPluralize(props.region[0].stats.offers_count_for_sale)}`
                            : `w całej Polsce realizują ${numberFormat(props.allOffersCount)} ${offersPluralize(props.allOffersCount)}`}
                    </Text>
                </>
            )}
        </header>
    );
};

const subheaderStyle = (theme: Theme) => css`
    color: ${theme.colors.gray[600]};
`;

const nonBreakable = css`
    white-space: nowrap;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {generateMetaRegionNameDeclensionWhere} from "../../../meta_data/utils/generate_meta_region_name_declension_where";
import {RegionType} from "../../../region/types/RegionType";

interface IProps {
    allOffersCount: number;
    className?: string;
    vendorsCount: number;
    region:
        | {
              full_name: string;
              is_duplicate: boolean;
              name: string;
              name_declension_what: string;
              name_declension_where: string;
              parent: {
                  name: string;
              } | null;
              short_name: string;
              stats: {
                  offers_count_for_sale: number;
              };
              type: RegionType;
          }[]
        | null;
    page: number;
}

export const VendorListHeader = (props: IProps) => {
    const vendorsPluralize = pluralize(["dewelopera", "deweloperów", "deweloperów"]);
    const offersPluralize = pluralize(["inwestycję", "inwestycje", "inwestycji"]);

    return (
        <header className={props.className}>
            {props.vendorsCount === 0 && (
                <SeoMainHeadline as="h1" variant="headline_2" css={pb(1)}>
                    Brak deweloperów {props.region && props.region[0] ? generateMetaRegionNameDeclensionWhere(props.region[0]) : "w wybranym regionie"}
                </SeoMainHeadline>
            )}
            {props.vendorsCount > 0 && (
                <>
                    <SeoMainHeadline as="h1" variant="headline_2" highlight css={pb(1)} prefixContent="Znaleźliśmy" pageString={` - Strona ${props.page}`}>
                        {numberFormat(props.vendorsCount)} {vendorsPluralize(props.vendorsCount)}{" "}
                        {props.region && props.region[0] ? generateMetaRegionNameDeclensionWhere(props.region[0]) : "z całej Polski"}
                        {props.page > 1 && (
                            <>
                                {" - "}
                                <span css={nonBreakable}>Strona {props.page}</span>
                            </>
                        )}
                    </SeoMainHeadline>

                    <Text as="h2" variant="body_copy_1" css={subheaderStyle}>
                        Aktualnie nasi deweloperzy{" "}
                        {props.region
                            ? `${props.region[0].name_declension_where} realizują ${numberFormat(
                                  props.region[0].stats.offers_count_for_sale
                              )} ${offersPluralize(props.region[0].stats.offers_count_for_sale)}`
                            : `w całej Polsce realizują ${numberFormat(props.allOffersCount)} ${offersPluralize(props.allOffersCount)}`}
                    </Text>
                </>
            )}
        </header>
    );
};

const subheaderStyle = (theme: Theme) => css`
    color: ${theme.colors.gray[600]};
`;

const nonBreakable = css`
    white-space: nowrap;
`;
